import api, { LOCALE_HOST } from '../../../helpers/api';
import { getNestAPIHost } from '../../../helpers/multiRegion';
import { MESSAGE_SLUGS } from '../../../helpers/constants';
import { xcmsAPI } from '.';

const messagesAPI = xcmsAPI.injectEndpoints({
  endpoints: (builder) => ({
    fetchMessages: builder.query<Record<string, string>, { locale: string; reqInit: RequestInit }>({
      async queryFn({ locale, reqInit }) {
        try {
          const res = await api.get<Record<string, string>>(
            `${LOCALE_HOST}${getNestAPIHost()}/messages/frontend/${
              MESSAGE_SLUGS.FE_MESSAGES_SLUG
            }/?language=${locale}`,
            false,
            reqInit,
          );
          return {
            data: res,
          };
        } catch (error: any) {
          return { error };
        }
      },
      serializeQueryArgs: ({ queryArgs: { locale } }) => ({ locale }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useFetchMessagesQuery,
  util: { getRunningQueriesThunk },
} = messagesAPI;
export const { fetchMessages } = messagesAPI.endpoints;
